import React, { useEffect } from 'react';
import { PropTypes } from 'prop-types';
import { connect, useDispatch } from 'react-redux';

import LinkWhsOperationStatus from 'components/LinkWhsOperationStatus';

import { GetLinkOperationStatuses } from 'actions';

const LinkWhsOperationMultiMonitor = ({
  accounts,
  onActiveMonitorsChange,
  isGettingWhsLinkStatuses,
  whsLinkStatuses,
  whsLinkMultiMonitorFailed
}) => {
  const dispatch = useDispatch();
  let interval;

  const getStatus = async () => {
    dispatch(GetLinkOperationStatuses(accounts?.map(x => x.value)));
  };

  useEffect(() => {
    getStatus();

    interval = setInterval(() => {
      getStatus();
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (onActiveMonitorsChange) {
      const activeMonitors = whsLinkStatuses?.filter(x => x.status < 100).map(x => x.fromAccountId);
      onActiveMonitorsChange(activeMonitors);
    }
  }, [whsLinkStatuses]);

  const accountIds = accounts?.map(x => x.value) ?? [];

  return !isGettingWhsLinkStatuses
    && whsLinkStatuses
    && whsLinkStatuses.length > 0
    && <React.Fragment>
      { !whsLinkMultiMonitorFailed && whsLinkStatuses.filter(x => accountIds.includes(x.fromAccountId)).map((x) => {
        let account = accounts.filter(a => a.value === x.fromAccountId);
        account = account && account.length > 0 ? account : accounts.filter(a => a.value === x.toAccountId);
        const accountNumber = account?.length > 0 ? account[0].label : '';
        return (<React.Fragment>
          <h2><strong>Account locked: { accountNumber }</strong></h2>
          <LinkWhsOperationStatus
            key={ `${ x.fromAccountId }-${ x.toAccountId }` }
            accountWhsLinkStatus={ x }
            showExplanation={ false }
            accountWhsLinkMonitorFailed={ whsLinkMultiMonitorFailed }
          />
        </React.Fragment>);
      }) }
      { !whsLinkMultiMonitorFailed && whsLinkStatuses && whsLinkStatuses.length > 0 && <React.Fragment>
        <p>For simple IMY Structure this will take a few seconds. For larger structures this may take a few minutes.</p>
        <p>The IMY Structure and Linked Accounts will <strong>not</strong> be editable until the linking is complete.</p>
      </React.Fragment> }
      { whsLinkMultiMonitorFailed
     && <div className="d-inline-flex" style={ { alignItems: 'baseline', width: '100%', justifyContent: 'space-between' } }>
       <p style={ { color: 'red' } }>An error has occured retrieving the status of the accounts selected. Please wait or re-select the accounts.</p>
     </div>}
    </React.Fragment>;
};

LinkWhsOperationMultiMonitor.propTypes = {
  accounts: PropTypes.arrayOf(PropTypes.shape),
  onActiveMonitorsChange: PropTypes.func,
  isGettingWhsLinkStatuses: PropTypes.bool,
  whsLinkStatuses: PropTypes.arrayOf(PropTypes.shape),
  whsLinkMultiMonitorFailed: PropTypes.bool
};

LinkWhsOperationMultiMonitor.defaultProps = {
  accounts: [],
  onActiveMonitorsChange: undefined,
  isGettingWhsLinkStatuses: false,
  whsLinkStatuses: [],
  whsLinkMultiMonitorFailed: false,
};

function mapStateToProps(state) {
  const {
    account: {
      isGettingWhsLinkStatuses,
      whsLinkStatuses,
      whsLinkMultiMonitorFailed
    }
  } = state;

  return {
    isGettingWhsLinkStatuses,
    whsLinkStatuses,
    whsLinkMultiMonitorFailed
  };
}

export default connect(mapStateToProps)(LinkWhsOperationMultiMonitor);
